<template>
  <div class="city-tag" :class="{'is-active':isActive}" @click="handlerClick">
    <slot>{{ label }}</slot>
    <i class="city-tag__close el-icon-close" v-if="closable" @click="handleClose"></i>
  </div>
</template>

<script>
export default {
  name: "cityTag",
  props:{
    label:{
      type:String,
      default:"标签",
    },
    closable: Boolean,
    isActive: Boolean,
  },
  methods:{
    handleClose(event) {
      event.stopPropagation();
      this.$emit('close', event);
    },
    handlerClick(event) {
      event.stopPropagation();
      this.$emit('click', event);
    },
  }
}
</script>

<style scoped lang="scss">
.city-tag{
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 29px;
  font-size: 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  background-color: #fff;
  border-color:#dcdfe6;
  color: #606266;
  &:not(.is-active),
  &:not(.is-disabled){
    cursor: pointer;
  }
  &:not(.is-active):hover{
    background-color: #fff;
    border-color: #f1d7da;
    color: #FF4D01;
  }
  &.is-active{
    background-color: #FF4D01;
    border-color: #FF4D01;
    color: #fff;
    .el-icon-close {
      &:hover{
        color: #FF4D01;
        background-color: #fff;
      }
    }
  }
  .el-icon-close {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 18px;
    width: 18px;
    line-height: 18px;
    vertical-align: middle;
    top: 0;
    right: -5px;
    &:hover{
      color: #fff;
      background-color: #FF4D01;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/city-tag/index.vue